import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { HeartHandshake, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function StartNonprofit() {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const start = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/api/portal/clarity-hub/nonprofit`, { name }, { withCredentials: true });
      toast.success('Your Nonprofit Launch track is started. David has been notified.');
      window.location.reload();
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not start your nonprofit track'); setBusy(false); }
  };
  return (
    <form onSubmit={start} className="border border-dashed border-fuchsia-200 rounded-xl p-4" data-testid="start-nonprofit-form">
      <p className="text-sm text-[#64748B] mb-3">Planning a nonprofit? Start your 90-day launch track. David will guide each step with you.</p>
      <div className="flex gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nonprofit name (working title is fine)" required data-testid="start-nonprofit-name"
          className="flex-1 min-w-0 border border-[#E2E8F0] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-fuchsia-300" />
        <button disabled={busy} data-testid="start-nonprofit-submit" className="inline-flex items-center gap-1.5 bg-fuchsia-600 hover:bg-fuchsia-700 text-white text-sm font-semibold px-4 py-2 rounded-lg disabled:opacity-60">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <HeartHandshake size={14} />} Start
        </button>
      </div>
    </form>
  );
}
